import { ArticleDayreport } from './article-dayreport.class';
import { Declaration } from './declaration.class';
import { Planning } from './planning.class';
import { Status } from './status.class';

export class Dayreport {
    id: number;
    planning_id: number;
    planning?: Planning;
    status_key: string;
    status?: Status;
    comment?: string;
    form_data?: Record<string, any>;
    created_at: Date;
    updated_at: Date;
    article_dayreports?: ArticleDayreport[];
    declaration_id?: number;
    declaration?: Declaration;
}
